module.exports = __webpack_public_path__ + "img/logo-yinyang.04d74197.png";